import React from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'

const UpdatedOn = props => {
  const { date } = props
  return (
    <p className="uppercase text-xs text-body-lighter font-semibold">
      Updated on: {moment(date).format('DD MMMM YYYY')}
    </p>
  )
}

UpdatedOn.propTypes = {
  date: PropTypes.string,
}

export default UpdatedOn
